<div class="mt-2" [formGroup]="formGroup">
  <div class="col-12 mb-3">
    <span
      class="text-sm font-medium card-title"
      [ngClass]="{ required: fields.isRequired }"
      >{{ fields.displayName }}</span
    >
  </div>
  <div class="col-12 d-flex flex-wrap gap-2">
    <ng-container *ngFor="let option of fieldsData" class="ms-3">
      <span
        class="mb-3 inline-flex items-center gap-2 px-3 py-1 rounded-lg border text-sm font-medium cursor-pointer transition-all hover:bg-secondary-active"
        [ngClass]="{
          'bg-light-warning text-gray-700': selectedOptions.includes(
            option._id
          ),
          'bg-white dark:bg-coal-700 text-gray-700': !selectedOptions.includes(
            option._id
          ),
          'disable-field': disableFields == true,
        }"
        [ngStyle]="{
          borderColor: selectedOptions.includes(option._id)
            ? '#F39C12'
            : '#D1D5DB',
        }"
        (click)="toggleSelection(option)"
      >
        <img
          *ngIf="option.iconUrl"
          [src]="option.iconUrl"
          class="h-20px w-20px"
        />
        <i
          *ngIf="option.icon"
          [class]="option.icon"
          [ngStyle]="{
            color: selectedOptions.includes(option._id) ? '#F39C12' : '#6B7280',
          }"
        ></i>
        <span class="text-2sm font-semibold text-gray-700">{{
          option.name
        }}</span>
      </span>
    </ng-container>
  </div>
  <!-- Validation Message -->
  <div
    *ngIf="
      fields.isRequired &&
      selectedOptions.length == 0 &&
      formGroup.get(fields.fieldName)?.touched
    "
    class="text-danger text-sm mt-1"
  >
    Please select {{ fields.displayName }}
  </div>
</div>
